import { IsNotEmpty, IsString } from '../utils/ClassValidators'


export class BasicCreateFormValidator {
    @IsString()
    @IsNotEmpty()
    name: string
}